import { LoggingFacade } from '@vwdfive/myvw-logging';
import { CarNetShopClient, IArticle } from './CarNetShopClient';

export class CarNetShopService {
    constructor(private readonly loggingFacade: LoggingFacade, private readonly carNetShopClient: CarNetShopClient,
                private readonly shopLocale: string, private readonly shopCountry: string) {
    }

    public async hasAppArticles(vin: string, isWcar: boolean): Promise<boolean> {
        const articlesForApp = await this.getArticlesForCategory(vin, isWcar, 'APP');
        return articlesForApp.length > 0;
    }

    public async hasFodArticles(vin: string, isWcar: boolean): Promise<boolean> {
        const articlesForFod = await this.getArticlesForCategory(vin, isWcar, 'FOD');
        return articlesForFod.filter(article => article.available).length > 0;
    }

    private async getArticlesForCategory(vin: string, isWcar: boolean, category: string): Promise<IArticle[]> {
        try {
            const carNetResponse = await this.carNetShopClient.getArticleInformation(vin, isWcar,
                this.shopCountry, this.shopLocale);
            return carNetResponse.vehicles[0]?.articles.filter((article) => article.category === category) ?? [];
        } catch (e: any) {
            this.loggingFacade.error('Fetching data from CarNetShop failed', e);
            return [];
        }
    }
}